import AldrichRegular from '@/assets/chromabet/fonts/Aldrich-Regular.ttf';

import ProximaNovaAltBold from '@/assets/chromabet/fonts/ProximaNova-Alt-Bold.otf';
import ProximaNovaAltLight from '@/assets/chromabet/fonts/ProximaNova-Alt-Light.otf';
import ProximaNovaAltThin from '@/assets/chromabet/fonts/ProximaNova-Alt-Thin.otf';
import ProximaNovaBlack from '@/assets/chromabet/fonts/ProximaNova-Black.otf';
import ProximaNovaBold from '@/assets/chromabet/fonts/ProximaNova-Bold.otf';
import ProximaNovaExtrabold from '@/assets/chromabet/fonts/ProximaNova-Extrabold.otf';
import ProximaNovaThin from '@/assets/chromabet/fonts/ProximaNova-Thin.otf';
import ProximaNovaRegular from '@/assets/chromabet/fonts/ProximaNova-Regular.otf';

export const fontFace = `
        @font-face {
          font-family: 'ProximaNovaAlt';
          font-style: normal;
          font-weight: 700;
          font-display: swap;
          src: url('${ProximaNovaAltBold}') format('opentype');
        }
        @font-face {
          font-family: 'ProximaNovaAlt';
          font-style: normal;
          font-weight: 300;
          font-display: swap;
          src: url('${ProximaNovaAltLight}') format('opentype');
        }
        @font-face {
          font-family: 'ProximaNovaAlt';
          font-style: normal;
          font-weight: 100;
          font-display: swap;
          src: url('${ProximaNovaAltThin}') format('opentype');
        }
        @font-face {
          font-family: 'ProximaNova';
          font-style: normal;
          font-weight: 900;
          font-display: swap;
          src: url('${ProximaNovaBlack}') format('opentype');
        }
        @font-face {
          font-family: 'ProximaNova';
          font-style: normal;
          font-weight: 800;
          font-display: swap;
          src: url('${ProximaNovaExtrabold}') format('opentype');
        }
        @font-face {
          font-family: 'ProximaNova';
          font-style: normal;
          font-weight: 700;
          font-display: swap;
          src: url('${ProximaNovaBold}') format('opentype');
        }
        @font-face {
          font-family: 'ProximaNova';
          font-style: normal;
          font-weight: 400;
          font-display: swap;
          src: url('${ProximaNovaRegular}') format('opentype');
        }
        @font-face {
          font-family: 'ProximaNova';
          font-style: normal;
          font-weight: 100;
          font-display: swap;
          src: url('${ProximaNovaThin}') format('opentype');
        }
        
        @font-face {
          font-family: 'Aldrich';
          font-style: normal;
          font-weight: 400;
          font-display: swap;
          src: url('${AldrichRegular}') format('opentype');
        }
      `;
